import { makeStyles } from "tss-react/mui";

import { Box, Theme } from "@mui/material";

const useStyles = makeStyles()((theme: Theme) => ({
    card: {
        minHeight: "134px",
        border: "1px solid " + theme.palette.emteria.border.primary,
        borderRadius: "8px",
        backgroundColor: theme.palette.emteria.background.paper,
    },
}));

type Props = {
    children: React.ReactNode;
    className?: string;
};

export const Card = (props: Props) => {
    const { classes, cx } = useStyles();
    return <Box className={cx(classes.card, props.className)}>{props.children}</Box>;
};
